import React from 'react';
import { CURRENT_INSTANCE } from '@lib/utils';
import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';

function NoAnswerResponse() {
  const { t } = useTranslation();
  const medInfoLink = CURRENT_INSTANCE.medInfoLink;
  const medInfoText = CURRENT_INSTANCE.medInfoText;

  return (
    <AnswerMessageContainer>
      <div>
        {t('chat.response.contact_medical_info_long')}
        <br />
        <br />
        {medInfoText.split('\n').map((line, index) => {
          if (line.startsWith('E-Mail')) {
            const [title, emailAddress] = line.split(':');
            return (
              <React.Fragment key={index}>
                <span>{title}: </span>
                <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                <br />
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          );
        })}
        <br />
        <a target="_blank" href={medInfoLink}>
          {medInfoLink}
        </a>
      </div>
    </AnswerMessageContainer>
  );
}

export default NoAnswerResponse;
